import * as api from 'services/ErplyAPI/assortmentProducts';
import { ASSORTMENT_PRODUCTS } from 'containers/EssentialDataLoader/constants';
import { getLoggedInWarehouse } from 'reducers/warehouses';
import { createAsyncThunkWithIndexedDbPersister } from 'containers/EssentialDataLoader/utils';
import { CAFA_LEVELS } from 'constants/CAFA';

import * as constants from '../constants/assortmentProducts';

export const getAssortmentProducts = createAsyncThunkWithIndexedDbPersister(
  ASSORTMENT_PRODUCTS,
  constants.GET_ASSORTMENT_PRODUCTS,
  async (_, { getState }) => {
    const warehouse = getLoggedInWarehouse(getState());
    const { warehouseID, assortmentID } = warehouse;
    if (!assortmentID) return [];
    try {
      const payload = await api.getAssortmentProducts(
        warehouseID,
        assortmentID,
      );
      return payload;
    } catch (err) {
      console.error('Failed to fetch assortment products', err);
      throw err;
    }
  },
  {
    provideLevel: state => {
      const warehouse = getLoggedInWarehouse(state);
      return {
        level: CAFA_LEVELS.Warehouse,
        id: String(warehouse.warehouseID),
      };
    },
  },
);
